import { useState, useEffect } from 'react';
import Item from './Item-b4';

const youtubeURL = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyBQGafGvTQLU6RWDD5VpOj6mEsPPdg8gUs&channelId=UCUe3zC8exy2gZqxvom_eE-w&part=snippet,id&order=date&maxResults=50';

function Items() {
  const [videos, setVideos] = useState([])
 
  const fetchYoutubeVideos = () => {
    fetch(youtubeURL)
      .then(response => {
        return response.json()
      })
      .then(data => {
        setVideos(data.items)
      })
  };
  
  useEffect(() => {
    fetchYoutubeVideos()
  }, [])
  
  return (
    <>
      {videos.length > 0 && (
        <div className="grid grid-cols-1">
          {videos.map(video => (
            <Item key={video.id.videoId} data={video} />
          ))}
        </div>
      )}
    </>
  );
}

export default Items;